import { useState } from 'react'
//import format from "../utils/format"

const useAppState = () => {
  //let todayDate = new Date()
  let nextYearDate = new Date()
  nextYearDate.setFullYear(nextYearDate.getFullYear() + 1)
  nextYearDate.setDate(nextYearDate.getDate() - 1)
  const [insured, setInsured] = useState({
    policy: '',
    nric: '',
    mobile: '',
    name: '',
    id: '',
    dateOfBirth: '',
    gender: '',
    height: '',
    weight: '',
    email: '',
    nationality: 'MY',
    occupation: '',
    address1: '',
    address2: '',
    address3: '',
    postcode: '',
    addState: '',
    declare1: '',
    declare2: '',
    declare3: '',
    pdpaAgree: '',
    tncAgree: '',
    selectedPlan: '',
    renewalFrom: '',
    renewalTo: '',
    pocFrom: '', //`${todayDate.getDate()}/${todayDate.getMonth() + 1}/${todayDate.getFullYear()}`,
    pocTo: '', //`${nextYearDate.getDate()}/${nextYearDate.getMonth() + 1}/${nextYearDate.getFullYear()}`,
    customerType: '',
    effDate: '',
    expDate: '',
    occ: '',
    occ_class: '',
    txid: '',
    city: '',
    stated: '',
    type: 'N',
    amla: '0', // 0 - new, 1 - okay, 2 - got issue
    maritalstatus: '',
    renewal_plan1: '',
    renewal_plan2: '',
    renewal_plan3: '',
  })

  const [plans, setPlans] = useState([
    {
      name: 'Plan 1',
      code: 'Plan 1',
      grossPremium: 645,
      rebate: 161.25,
      grossPremiumAfterRebate: 0,
      sstpct: 8,
      serviceTax: 38.7,
      stampDuty: 0,
      total: 522.45,
      total2: 0,
    },
    {
      name: 'Plan 2',
      code: 'Plan 2',
      grossPremium: 520,
      rebate: 130.0,
      grossPremiumAfterRebate: 0,
      sstpct: 8,
      serviceTax: 31.2,
      stampDuty: 0,
      total: 421.2,
      total2: 0,
    },
    {
      name: 'Plan 3',
      code: 'Plan 3',
      grossPremium: 380,
      rebate: 95.0,
      grossPremiumAfterRebate: 0,
      sstpct: 8,
      serviceTax: 22.8,
      stampDuty: 0,
      total: 307.8,
      total2: 0,
    },
  ])

  // const reduceInsured = state => {
  //   const nationality = state.nationality || insured.nationality
  //   let id = state.id || insured.id
  //   let nric = ''
  //   if (state.dateOfBirth && nationality === 'MY') {
  //     const dob = format.date(state.dateOfBirth)
  //     nric = `${dob.substr(-2)}${dob.substr(3, 2)}${dob.substr(0, 2)}` + '-'
  //   }

  //   setInsured({
  //     ...insured,
  //     ...state,
  //     id: nric ? nric : id
  //   })
  // }

  const [language, setLanguage] = useState('en')

  const [tin, setTin] = useState('')
  const [showMaintenance, setShowMaintenance] = useState({ title: '', message: '' })

  return {
    insured,
    //setInsured: reduceInsured,
    setInsured,
    plans,
    setPlans,
    language,
    setLanguage,
    tin,
    setTin,
    showMaintenance,
    setShowMaintenance,
  }
}

export default useAppState
